export default {
    methods: {
        isUserStaff(){
            const user = JSON.parse(localStorage.getItem('activeUser'))
            return user.isStaff
        }
    }
}
